/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Failure_Warehouse_FailedInputs */

const en_sync_failure_warehouse_failed = /** @type {(inputs: Sync_Failure_Warehouse_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The warehouse could not take the last instruction sent for a technical problem. Send again.`)
};

/**
* | output |
* | --- |
* | "The warehouse could not take the last instruction sent for a technical problem. Send again." |
*
* @param {Sync_Failure_Warehouse_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_failure_warehouse_failed = /** @type {((inputs?: Sync_Failure_Warehouse_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Failure_Warehouse_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_failure_warehouse_failed(inputs)
});